/* =====================================================================
   PROMOCJA: DARMOWA BATERIA  (miekidom.shop / theme Meka 5.0.3)
   ---------------------------------------------------------------------
   Mechanika:
   - klient dodaje produkt o kwalifikującym SKU,
   - wyskakuje responsywny popup z wyborem baterii,
   - wybrana bateria (wariant 0 zł z ukrytego produktu "Bateria gratis")
     trafia do koszyka jako osobna linia z property _free_battery=true,
   - maks. 1 darmowa bateria na zamówienie,
   - usunięcie wszystkich kwalifikujących produktów -> bateria znika.

   Plik jest sterowany configiem (sekcja CONFIG). Nie ma tu logiki
   serwerowej — "0 zł" zapewnia cena wariantu (3 warianty po 0 zł).
   ===================================================================== */

(function () {
  'use strict';

  /* ===================== CONFIG — DO UZUPEŁNIENIA ===================== */

  // ID WARIANTÓW ukrytego produktu "Bateria gratis" (3 warianty po 0 zł).
  // Wstaw liczbowe variant_id (NIE product_id). Po utworzeniu produktu
  // możesz je odczytać z URL wariantu w adminie lub przez Admin API.
  var GIFT_VARIANTS = {
    '2':   63821111558521,   // GRATIS-2    Bateria JCB 2ah
    '4HC': 63821111591289,   // GRATIS-4HC  Bateria JCB 4ah szybkie ładowanie
    '5':   63821111624057    // GRATIS-5    Bateria JCB 5ah
  };

  // Handle ukrytego produktu "Bateria Gratis" — do blokady stepera ilości
  // i ukrywania kart produktu w katalogu/wyszukiwarce.
  var GIFT_HANDLE = 'bateria-gratis';

  // Czy ukrywać karty produktu gratisowego na listingach (kolekcje, /collections/all,
  // wyszukiwarka, polecane). Stopgap po stronie JS — docelowo lepiej filtrem w szablonie karty.
  var HIDE_FROM_CATALOG = true;

  // Czy blokować edycję ilości linii gratisowej (stepper) w koszyku i drawerze.
  var LOCK_GIFT_QTY = true;

  // Czy honorować ograniczenie "Only 5ah battery" dla 20 SKU z pliku?
  // false (domyślnie) = przy każdym kwalifikującym SKU pełny wybór 3 baterii.
  // true = dla SKU z listy ONLY_5AH popup pokaże wyłącznie baterię 5 Ah.
  var HONOR_5AH_RESTRICTION = false;

  // Czy automatycznie usuwać darmową baterię, gdy w koszyku nie ma już
  // żadnego kwalifikującego produktu.
  var AUTO_REMOVE = true;

  // Teksty popupu, etykiety baterii i link do regulaminu (z prefiksem /uk, /uk-ua):
  // locales free_battery.* (pl.json + uk), wystawione jako window.freeBatteryText
  // w header-group, sekcja „Darmowa Bateria – teksty popupu”.
  var TEXT = window.freeBatteryText || {};
  var BATTERY_LABELS = {
    '2':   { title: TEXT.battery_2, sub: 'GRATIS-2' },
    '4HC': { title: TEXT.battery_4hc, sub: 'GRATIS-4HC' },
    '5':   { title: TEXT.battery_5, sub: 'GRATIS-5' }
  };
  var REGULAMIN_URL = TEXT.termsUrl;

  // Kwalifikujące SKU (148). Matcher normalizuje myślniki, więc U+2011
  // i zwykły "-" są traktowane tak samo.
  var QUALIFYING = ["ZK400A_3","ZK400AL_3","ZK400AL_6","ZK250A_3","ZK250AL_3","ZK250AL_6","ZK2000A_3","ZK2000AL_3","ZK2000AL_6","ZK2300A_3","ZK2300AL_3","ZK2300AL_6","ZKW75A_1","ZKW75A_2","ZKW75A_3","ZKW75AL_1","ZKW75AL_6","ZKW75AL_3","ZKW75AL_5","ZKW75AL_4","ZKW75AL_2","ZMO_3","ZMOAL_3","ZMOAL_6","ZP185A_3","ZP185AL_3","ZP185AL_6","ZSM_1","ZSM_2","ZSM_3","ZSMAL_1","ZSMAL_4","ZSMAL_2","ZSMAL_3","ZSMAL_5","ZSMAL_6","ZSZA_3","ZSZAL_6","ZSZGA_3","ZSZGAL_3","ZSZGAL_6","ZSZM_1","ZSZM_2","ZSZM_3","ZSZMAL_1","ZSZMAL_4","ZSZMAL_2","ZSZMAL_3","ZSZMAL_5","ZSZMAL_6","ZSZT_3","ZSZTAL_3","ZSZTAL_6","ZW160A_1","ZW160A_2","ZW160A_3","ZW160AL_1","ZW160AL_4","ZW160AL_2","ZW160AL_3","ZW160AL_5","ZW160AL_6","ZZA_1","ZZA_2","ZZA_3","ZZAL_1","ZZAL_4","ZZAL_2","ZZAL_3","ZZAL_5","ZZAL_6","ZW_1","ZW_2","ZW_3","ZWAL_1","ZWAL_4","ZWAL_2","ZWAL_3","ZWAL_5","ZWAL_6","JCB-18PKIT-1","JCB-18PCD-75-5","JCB-18PCD-160-5","JCB-18PKIT-3","JCB-18PKIT-2","JCB-18PIW-350‑SET‑zestaw-1","JCB-18PIW-620‑zestaw-1","JCB‑18FPAG-PCD75-zestaw-1","JCB-18PCD-75‑zestaw-2","JCB-18PID-230‑zestaw-1","JCB-18PKIT-8","JCB‑PRO18V‑SERVKIT‑zestaw-1","JCB‑PRO18V‑SERVKIT‑zestaw-2","JCB‑PRO18V‑SERVKIT‑zestaw-3","JCB-18PKIT-5","JCB‑18PGG-zestaw-1","JCB‑18PAG-PCD160-zestaw-2","JCB‑18PAG-PCD75-zestaw-2","JCB‑18POS-zestaw-1","JCB‑18FPAG-PCD160-zestaw-1","JCB‑GRIND‑zestaw-1","JCB-18PKIT-4","JCB-18PKIT-7","ZK250A_4","ZK250AL_7","ZK250AL_8","ZK400A_4","ZK400AL_7","ZK400AL_8","ZK2000A_4","ZK2000AL_7","ZK2000AL_8","ZK2300A_4","ZK2300AL_7","ZK2300AL_8","ZKW75A_4","ZKW75AL_7","ZKW75AL_8","ZW160A_4","ZW160AL_7","ZW160AL_8","ZZA_4","ZZAL_7","ZZAL_8","ZSM_4","ZSMAL_7","ZSMAL_8","ZSZA_4","ZSZAL_7","ZSZAL_8","ZSZGA_4","ZSZGAL_7","ZSZGAL_8","ZP185A_4","ZP185AL_7","ZP185AL_8","ZSZM_4","ZSZMAL_7","ZSZMAL_8","ZSZT_4","ZSZTAL_7","ZSZTAL_8","ZW_4","ZWAL_7","ZWAL_8","ZMO_4","ZMOAL_7","ZMOAL_8"];

  // SKU z flagą "Only 5ah battery" (26) — używane tylko gdy HONOR_5AH_RESTRICTION=true.
  var ONLY_5AH = ["ZK400A_3","ZK400AL_3","ZK400AL_6","ZK250A_3","ZK250AL_3","ZK250AL_6","ZK2000A_3","ZK2000AL_3","ZK2000AL_6","ZK2300A_3","ZK2300AL_3","ZK2300AL_6","ZMO_3","ZMOAL_3","ZMOAL_6","ZP185A_3","ZP185AL_3","ZP185AL_6","ZSZA_3","ZSZAL_6","ZSZGA_3","ZSZGAL_3","ZSZGAL_6","ZSZT_3","ZSZTAL_3","ZSZTAL_6"];

  // Korpusy narzędzi z Załącznika 1 — kwalifikują się tylko razem z płatnym
  // akumulatorem z BATTERIES (§2 ust. 3). Linia gratisowa (GRATIS-*) się nie liczy.
  var KORPUS = ["JCB-18PIW-620","JCB-18PIW-350","JCB-18PIW-2000","JCB-18PIW-2300","JCB-18PCD-75","JCB-18PCD-160","JCB-18PID-230","JCB-18PMT-32","JCB-18PCS-185","JCB-18PGG-VS","JCB-18PAG-125","JCB-18PFAG-125","JCB-18POS-125","JCB-18PDG-6","JCB-18PJS-DG"];
  // 8 Ah uprawnia do gratisu, ale sam gratisem nie jest — wybór tylko z GIFT_VARIANTS (2/4/5 Ah).
  var BATTERIES = ["JCB-18LI-2","JCB-18LI-4HC","JCB-18LI-5","JCB-18LI-8HC"];

  /* =================== KONIEC CONFIG =================== */

  var FREE_PROP = '_free_battery';
  var busy = false; // blokada reentrancji (własne operacje na koszyku)

  function norm(s) {
    return String(s == null ? '' : s)
      .replace(/[\u2010\u2011\u2012\u2013\u2014\u2212]/g, '-') // wszystkie myślniki -> ASCII
      .trim()
      .toUpperCase();
  }

  var QUAL_SET = new Set(QUALIFYING.map(norm));
  var ONLY5_SET = new Set(ONLY_5AH.map(norm));
  var KORPUS_SET = new Set(KORPUS.map(norm));
  var BATTERY_SET = new Set(BATTERIES.map(norm));

  function isQualifying(sku) { return QUAL_SET.has(norm(sku)); }

  function allowedKeys(sku) {
    if (HONOR_5AH_RESTRICTION && ONLY5_SET.has(norm(sku))) return ['5'];
    return Object.keys(GIFT_VARIANTS).filter(function (k) { return GIFT_VARIANTS[k]; });
  }

  function giftVariantIds() {
    return Object.keys(GIFT_VARIANTS)
      .map(function (k) { return GIFT_VARIANTS[k]; })
      .filter(Boolean)
      .map(String);
  }

  function getCart() {
    return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function cartHasFreeBattery(cart) {
    var giftIds = giftVariantIds();
    return (cart.items || []).some(function (it) {
      var byProp = it.properties && (it.properties[FREE_PROP] === 'true' || it.properties[FREE_PROP] === true);
      var byId = giftIds.indexOf(String(it.id)) !== -1;
      return byProp || byId;
    });
  }

  function cartHasQualifying(cart) {
    var items = cart.items || [];
    if (items.some(function (it) { return isQualifying(it.sku); })) return true;
    return items.some(function (it) { return KORPUS_SET.has(norm(it.sku)); }) &&
           items.some(function (it) { return BATTERY_SET.has(norm(it.sku)); });
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  // Buduje FormData zgodnie z konwencją Meka (sekcje do re-renderu drawera).
  function buildAddBody(variantId) {
    var drawer = getCartDrawer();
    var fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', '1');
    fd.append('properties[' + FREE_PROP + ']', 'true');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
    }
    return fd;
  }

  function addBattery(key) {
    var variantId = GIFT_VARIANTS[key];
    if (!variantId) { console.warn('[free-battery] Brak variant_id dla', key); return; }
    var drawer = getCartDrawer();
    var cfg = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : { method: 'POST', headers: {} };
    cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete cfg.headers['Content-Type'];
    cfg.body = buildAddBody(variantId);

    busy = true;
    return fetch(window.routes.cart_add_url, cfg)
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { console.warn('[free-battery] add error', res); return; }
        // Pełna strona /cart nie ma drawera -> przeładuj, żeby gratis był widoczny (jak w changeQty).
        if (isFullCartPage()) { window.location.reload(); return; }
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(res);
      })
      .catch(function (e) { console.error('[free-battery] add fail', e); })
      .finally(function () { busy = false; });
  }

  function isFullCartPage() {
    return !!document.querySelector('cart-items');
  }

  function changeQty(lineKey, qty) {
    var drawer = getCartDrawer();
    var cfg = (typeof fetchConfig === 'function') ? fetchConfig() : { method: 'POST', headers: { 'Content-Type': 'application/json' } };
    var body = { id: lineKey, quantity: qty };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    cfg.body = JSON.stringify(body);
    busy = true;
    return fetch(window.routes.cart_change_url, cfg)
      .then(function (r) { return r.json(); })
      .then(function (res) {
        // Pełna strona /cart renderuje sekcje main-cart-*, nie drawer -> przeładuj,
        // żeby skorygowana ilość/usunięcie były widoczne. W drawerze wystarczy renderContents.
        if (isFullCartPage()) { window.location.reload(); return res; }
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(res);
        return res;
      })
      .catch(function (e) { console.error('[free-battery] change fail', e); })
      .finally(function () { busy = false; });
  }

  function removeLine(lineKey) { return changeQty(lineKey, 0); }

  // Zwraca wszystkie linie koszyka rozpoznane jako darmowa bateria.
  function freeLines(cart) {
    var giftIds = giftVariantIds();
    return (cart.items || []).filter(function (it) {
      var byProp = it.properties && (it.properties[FREE_PROP] === 'true' || it.properties[FREE_PROP] === true);
      return byProp || giftIds.indexOf(String(it.id)) !== -1;
    });
  }

  function firstQualifyingSku(cart) {
    var it = (cart.items || []).find(function (i) { return isQualifying(i.sku); });
    return it ? it.sku : '';
  }

  /* ===================== POPUP (UI) ===================== */

  var overlayEl = null;
  var lastFocus = null;

  // Odmowa (Nie, dziękuję / × / tło / Esc) wstrzymuje automatyczne otwieranie do końca sesji.
  // Baner w koszyku i dodanie zestawu przez formularz produktu nadal otwierają popup.
  var DISMISS_KEY = 'fb_popup_dismissed';
  function isDismissed() { try { return sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { return false; } }
  function dismiss() { try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) {} }

  function closePopup() {
    if (!overlayEl) return;
    overlayEl.classList.remove('is-open');
    document.documentElement.style.removeProperty('overflow');
    var el = overlayEl;
    setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); }, 200);
    overlayEl = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function openPopup(keys) {
    if (overlayEl) return;
    lastFocus = document.activeElement;

    overlayEl = document.createElement('div');
    overlayEl.className = 'fb-overlay';
    overlayEl.setAttribute('role', 'dialog');
    overlayEl.setAttribute('aria-modal', 'true');
    overlayEl.setAttribute('aria-label', TEXT.heading);

    var options = keys.map(function (k) {
      var lab = BATTERY_LABELS[k] || { title: k, sub: '' };
      return (
        '<button type="button" class="fb-opt" data-key="' + k + '">' +
          '<span class="fb-opt__main">' +
            '<span class="fb-opt__title">' + lab.title + '</span>' +
            (lab.sub ? '<span class="fb-opt__sub">' + lab.sub + '</span>' : '') +
          '</span>' +
          '<span class="fb-opt__badge">' + TEXT.badge + '</span>' +
        '</button>'
      );
    }).join('');

    overlayEl.innerHTML =
      '<div class="fb-modal" role="document">' +
        '<button type="button" class="fb-close" aria-label="' + TEXT.close + '">&times;</button>' +
        '<h2 class="fb-heading">' + TEXT.heading + '</h2>' +
        '<p class="fb-desc">' + TEXT.desc + '</p>' +
        '<div class="fb-options">' + options + '</div>' +
        '<button type="button" class="fb-skip">' + TEXT.skip + '</button>' +
        '<p class="fb-terms"><a href="' + REGULAMIN_URL + '" target="_blank" rel="noopener">' + TEXT.terms + '</a></p>' +
      '</div>';

    document.body.appendChild(overlayEl);
    document.documentElement.style.overflow = 'hidden';
    // wymuszenie reflow dla animacji
    void overlayEl.offsetWidth;
    overlayEl.classList.add('is-open');

    overlayEl.addEventListener('click', function (e) {
      if (e.target === overlayEl || e.target.classList.contains('fb-close') || e.target.classList.contains('fb-skip')) {
        dismiss();
        closePopup();
        return;
      }
      var opt = e.target.closest && e.target.closest('.fb-opt');
      if (opt) {
        var key = opt.getAttribute('data-key');
        opt.classList.add('is-loading');
        addBattery(key).then(function () {
          closePopup();
          var d = getCartDrawer();
          if (d && typeof d.open === 'function') d.open();
        });
      }
    });

    document.addEventListener('keydown', function onEsc(e) {
      if (e.key === 'Escape') { if (overlayEl) { dismiss(); closePopup(); } document.removeEventListener('keydown', onEsc); }
    });

    var firstBtn = overlayEl.querySelector('.fb-opt');
    if (firstBtn) firstBtn.focus();
  }

  // Udostępnione globalnie — można podpiąć pod własny przycisk w drawerze.
  window.openFreeBatteryPopup = function (triggerSku, force) {
    if (!force && isDismissed()) return;              // odmowa w tej sesji (mostek w theme.liquid woła bez force)
    getCart().then(function (cart) {
      if (cartHasFreeBattery(cart)) return;            // 1 na zamówienie
      if (!cartHasQualifying(cart)) return;             // brak produktu kwalifikującego
      openPopup(allowedKeys(triggerSku || ''));
    });
  };

  /* ===================== LOGIKA WYZWALANIA ===================== */

  function extractAddedSkus(payload) {
    if (!payload) return [];
    var data = payload.cartData || payload;
    if (data && Array.isArray(data.items)) return data.items.map(function (i) { return i.sku; });
    if (data && data.sku) return [data.sku];
    return [];
  }

  // Sekwencyjne wykonanie operacji zmiany ilości [{key, qty}].
  function applyOps(ops) {
    return ops.reduce(function (p, op) {
      return p.then(function () { return changeQty(op.key, op.qty); });
    }, Promise.resolve());
  }

  // Wstrzykuje/usuwa przycisk powrotu do popupu — w drawerze i na pełnej stronie /cart.
  // Oba widoki re-renderują się, więc wołane po każdej zmianie koszyka.
  function syncCta(cart) {
    var shouldShow = cartHasQualifying(cart) && freeLines(cart).length === 0;

    // Host: drawer (stopka) albo pełny koszyk (przed main-cart-footer / w cart-items).
    var drawer = getCartDrawer();
    var host = null, anchor = null;
    if (drawer) {
      anchor = drawer.querySelector('.cart-drawer__footer') || drawer.querySelector('.drawer__footer');
      host = anchor ? anchor.parentNode : drawer.querySelector('.drawer__inner');
    }
    if (!host) {
      var cartFooter = document.getElementById('main-cart-footer');
      var cartItems = document.querySelector('cart-items');
      if (cartFooter) { anchor = cartFooter; host = cartFooter.parentNode; }
      else if (cartItems) { anchor = null; host = cartItems; }
    }
    if (!host) return;

    var existing = document.getElementById('fb-cta-banner');
    if (!shouldShow) { if (existing) existing.remove(); return; }

    var sku = firstQualifyingSku(cart);
    if (existing) { existing.setAttribute('data-sku', sku); return; }

    var banner = document.createElement('div');
    banner.id = 'fb-cta-banner';
    banner.className = 'fb-cta-banner';
    banner.setAttribute('data-sku', sku);
    banner.innerHTML =
      '<button type="button" class="fb-cta" data-sku="' + sku + '">' +
        '<span class="fb-cta__txt">' + TEXT.ctaBanner + '</span>' +
        '<span class="fb-cta__badge">' + TEXT.badge + '</span>' +
      '</button>';
    if (!drawer) { // pełna strona /cart: przycisk w szerokości treści koszyka, nie całego ekranu
      banner.style.padding = '12px 0';
      banner.innerHTML = '<div class="page-width">' + banner.innerHTML + '</div>';
    }

    if (anchor) anchor.insertAdjacentElement('beforebegin', banner);
    else host.appendChild(banner);
  }

  // Blokuje stepper ilości na liniach gratisowych (koszyk + drawer).
  function lockGiftQuantity() {
    if (!LOCK_GIFT_QTY) return;
    var giftIds = giftVariantIds();
    document.querySelectorAll('[data-quantity-variant-id]').forEach(function (el) {
      var vid = String(el.getAttribute('data-quantity-variant-id'));
      if (giftIds.indexOf(vid) === -1) return;
      var row = el.closest('.cart-item') || el.closest('.quantity') || el.parentNode;
      var box = row ? (row.querySelector('.quantity') || row) : null;
      if (!box) return;
      box.querySelectorAll('.quantity__input, .quantity__button, input, button').forEach(function (c) {
        c.setAttribute('disabled', 'disabled');
        c.style.pointerEvents = 'none';
        c.style.opacity = '0.5';
      });
    });
  }

  // Szuflada i /cart bywają przerysowywane bez cartUpdate (np. Bundler pobiera /cart?section_id=cart-drawer),
  // więc blokadę nakładamy od razu po każdej zmianie DOM – zanim przeglądarka obsłuży klik lub odmaluje stronę.
  function watchCartDom() {
    if (!LOCK_GIFT_QTY || !window.MutationObserver) return;
    new MutationObserver(lockGiftQuantity).observe(document.body, { childList: true, subtree: true });
  }

  // Ukrywa karty produktu gratisowego na listingach (kolekcje, /collections/all, search, polecane).
  // Nie rusza linii w koszyku (.cart-item).
  function hideGiftCards() {
    if (!HIDE_FROM_CATALOG) return;
    document.querySelectorAll('a[href*="/products/' + GIFT_HANDLE + '"]').forEach(function (a) {
      if (a.closest('.cart-item') || a.closest('cart-items') || a.closest('cart-drawer')) return;
      var card = a.closest('.card-wrapper, .grid__item, .card, li.grid__item, .product-card, .collection-product');
      if (card) card.style.display = 'none';
    });
  }

  function syncUi(cart) { syncCta(cart); lockGiftQuantity(); hideGiftCards(); }


  function onCartUpdate(payload) {
    if (busy) return;

    getCart().then(function (cart) {
      var fl = freeLines(cart);
      var hasQual = cartHasQualifying(cart);

      // 1) Osierocona bateria (brak produktu kwalifikującego) -> usuń wszystkie linie gratis.
      if (fl.length && !hasQual) {
        if (AUTO_REMOVE) {
          applyOps(fl.map(function (l) { return { key: l.key, qty: 0 }; }))
            .then(function () { getCart().then(syncUi); });
        }
        return;
      }

      // 2) Clamp: dokładnie jedna darmowa bateria w ilości 1.
      if (fl.length) {
        var ops = [];
        if (fl.length > 1) {
          fl.slice(1).forEach(function (l) { ops.push({ key: l.key, qty: 0 }); });
        }
        if (fl[0].quantity !== 1) ops.push({ key: fl[0].key, qty: 1 });
        if (ops.length) {
          applyOps(ops).then(function () { getCart().then(syncUi); });
          return;
        }
      }

      // 3) UI: przycisk powrotu + blokada stepera + ukrycie kart w katalogu.
      syncUi(cart);

      // 4) Otwarcie popupu po dodaniu kwalifikującego produktu przez product-form.
      if (!payload || payload.source !== 'product-form') return;
      var triggerSku = extractAddedSkus(payload).find(isQualifying);
      if (!triggerSku) return;
      if (cartHasFreeBattery(cart)) return; // 1 na zamówienie
      openPopup(allowedKeys(triggerSku));
    });
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      console.warn('[free-battery] Brak pub/sub Meka — sprawdź kolejność ładowania skryptu.');
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    watchCartDom();

    // Delegacja: przycisk powrotu jest odtwarzany przy każdym renderze drawera.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.fb-cta');
      if (!btn) return;
      e.preventDefault();
      window.openFreeBatteryPopup(btn.getAttribute('data-sku') || '', true);
    });

    // Stan początkowy (np. wejście na /cart lub listing z produktem kwalifikującym/gratisem).
    getCart().then(syncUi);
    hideGiftCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();